import { useTheme } from "next-themes";
import { Toaster as Sonner, ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
	const { theme = "system" } = useTheme();

	return (
		<Sonner
			theme={theme as ToasterProps["theme"]}
			position="top-center"
			duration={1800}
			expand={true}
			offset={{ right: "0", top: "78px" }}
			className="flex justify-center"
			toastOptions={{
				className: "toaster group",
				style: {
					backgroundColor: "var(--card)",
					color: "var(--t2)",
					border: "transparent",
					borderRadius: "30px 30px 30px 30px",
					fontSize: "14px",
					gap: "10px",
					padding: "12px 16px",
					boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.05)",
					width: "fit-content",
					marginInline: "auto",
					whiteSpace: "nowrap",
				},
			}}
			icons={{
				success: (
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
					>
						<path
							d="M12 0C5.3726 0 0 5.3726 0 12C0 18.6274 5.37257 24 12 24C18.6275 24 24 18.6274 24 12C24 5.3726 18.6274 0 12 0ZM19.0199 8.54473L10.2974 17.1551L4.88417 11.8786L6.59832 10.0547L10.2989 13.7553L17.2921 6.76209L19.0199 8.54473Z"
							fill="#0F943D"
						/>
					</svg>
				),
				error: (
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
					>
						<path
							d="M12 0C9.62663 0 7.30655 0.703788 5.33316 2.02236C3.35977 3.34094 1.8217 5.21508 0.913451 7.4078C0.00519934 9.60051 -0.232441 12.0133 0.230582 14.3411C0.693605 16.6689 1.83649 18.807 3.51472 20.4853C5.19295 22.1635 7.33115 23.3064 9.65892 23.7694C11.9867 24.2324 14.3995 23.9948 16.5922 23.0865C18.7849 22.1783 20.6591 20.6402 21.9776 18.6668C23.2962 16.6934 24 14.3734 24 12C24 8.8174 22.7357 5.76515 20.4853 3.51472C18.2348 1.26428 15.1826 0 12 0ZM17.94 16.248L16.248 17.94L12 13.692L7.752 17.94L6.06 16.248L10.308 12L6.06 7.752L7.752 6.06L12 10.308L16.248 6.06L17.94 7.752L13.692 12L17.94 16.248Z"
							fill="#EE3771"
						/>
					</svg>
				),
				loading: (
					<svg
						fill="#EE3771"
						viewBox="0 0 24 24"
						width="24"
						height="24"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path d="M10.72,19.9a8,8,0,0,1-6.5-9.79A7.77,7.77,0,0,1,10.4,4.16a8,8,0,0,1,9.49,6.52A1.54,1.54,0,0,0,21.38,12h.13a1.37,1.37,0,0,0,1.38-1.54,11,11,0,1,0-12.7,12.39A1.54,1.54,0,0,0,12,21.34h0A1.47,1.47,0,0,0,10.72,19.9Z">
							<animateTransform
								attributeName="transform"
								type="rotate"
								dur="0.75s"
								values="0 12 12;360 12 12"
								repeatCount="indefinite"
							/>
						</path>
					</svg>
				),
			}}
			style={
				{
					"--normal-bg": "var(--popover)",
					"--normal-text": "var(--popover-foreground)",
					"--normal-border": "var(--border)",
				} as React.CSSProperties
			}
			{...props}
		/>
	);
};

export { Toaster };
